/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
// Copyright (c) 2016 Deere & Company

import PlaceholderOption from './placeholder-option';
import PropTypes from 'prop-types';
import React from 'react';

function handleChange(event, prop) {

    if (prop.alwaysCallOnChange) {

        prop.onChange(event.target.value);

    } else if (event.target.value) {

        prop.onChange(event.target.value);

    }

}

function handleClick(e) {

    e.message = 'block';

}

const SelectList = (props) => (
    <select
        className="options-drop-down"
        onChange={(e) => handleChange(e, props)}
        onClick={(e) => handleClick(e)}
        value={props.selectedValue}
    >
        {props.showPlaceholder && (
            <PlaceholderOption
                isTranslated={props.isPlaceholderTranslated}
                text={props.placeholder}
            />
        )}
        {props.options.map((option, index) => (
            <option
                key={index}
                value={option[props.optionKey]}
            >
                {props.optionDisplayAttributes
                    .map((attribute) => option[attribute])
                    .join(' - ')
                }
            </option>
        ))}
    </select>
);

SelectList.displayName = 'SelectList';
SelectList.propTypes = {
    alwaysCallOnChange: PropTypes.bool.isRequired,
    isPlaceholderTranslated: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    optionDisplayAttributes: PropTypes.arrayOf(PropTypes.string).isRequired,
    optionKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.object).isRequired,
    placeholder: PropTypes.string.isRequired,
    selectedValue: PropTypes.string,
    showPlaceholder: PropTypes.bool,
};
SelectList.defaultProps = {
    showPlaceholder: true,
};

export default SelectList;
